import {
    FETCH_WAREHOUSES,
    FETCH_STOCK_ITEMS,
    FETCH_STOCK_CATEGORIES,
    FETCH_STOCK_MOVEMENTS,
    FETCH_STOCK_TRANSFERS,
    FETCH_STOCK_ALERTS,
    SET_LOADING,
    SET_ERROR,
} from '../actions/stockActions';

const initialState = {
    warehouses: {
        data: [],
        total: 0,
    },
    stockItems: {
        data: [],
        total: 0,
    },
    categories: {
        data: [],
        total: 0,
    },
    movements: {
        data: [],
        total: 0,
    },
    transfers: {
        data: [],
        total: 0,
    },
    alerts: {
        data: [],
        total: 0,
    },
    loading: false,
    error: null,
};

const stockReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WAREHOUSES:
            return {
                ...state,
                warehouses: action.payload,
            };
        case FETCH_STOCK_ITEMS:
            return {
                ...state,
                stockItems: action.payload,
            };
        case FETCH_STOCK_CATEGORIES:
            return {
                ...state,
                categories: action.payload,
            };
        case FETCH_STOCK_MOVEMENTS:
            return {
                ...state,
                movements: action.payload,
            };
        case FETCH_STOCK_TRANSFERS:
            return {
                ...state,
                transfers: action.payload,
            };
        case FETCH_STOCK_ALERTS:
            return {
                ...state,
                alerts: action.payload,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default stockReducer;





